// @flow
import React from 'react';
import type { MessageBlock as MessageBlockType } from 'message-parsing';

import TextBlock from './TextBlock';
import UrlBlock from './UrlBlock';
import MixedBlock from './MixedBlock';
import SpacingBlock from './SpacingBlock';
import type { ServiceBubblePropType } from './ServiceBubblePropType';

const messageBlockTypes = {
  TextBlock,
  UrlBlock,
  MixedBlock,
  SpacingBlock,
};

type MessageBlockProps = {
  block: MessageBlockType,
  inline?: boolean,
  serviceBubbles?: ServiceBubblePropType,
  handleLinkFormat: boolean,
};

/**
 * Render the given `MessageBlock` subclass instance, deferring to a
 * subclass specific component.
 *
 * @param {MessageBlockProps} props
 */
export default function MessageBlock({
  block,
  inline,
  serviceBubbles,
  handleLinkFormat,
}: MessageBlockProps) {
  // eslint-disable-line object-curly-newline
  const BlockComponent = block.constructor.name
    ? messageBlockTypes[block.constructor.name]
    : TextBlock;

  if (!BlockComponent) {
    throw new Error(
      `Can't render block type: ${block.constructor.name} - must be one of ${Object.keys(
        messageBlockTypes,
      ).join(', ')}`,
    );
  }

  return (
    <BlockComponent
      block={block}
      inline={inline}
      serviceBubbles={serviceBubbles}
      handleLinkFormat={handleLinkFormat}
    />
  );
}

MessageBlock.defaultProps = {
  inline: false,
  serviceBubbles: {},
};
